export const promoConstants = {
    CHECK_PROMO_CODE_SUCCESS: 'CHECK_PROMO_CODE_SUCCESS',
    CHECK_PROMO_CODE_FAILURE: 'CHECK_PROMO_CODE_FAILURE',

    SET_PROMO_HISTORY_OFFERS_SUCCESS: 'SET_PROMO_HISTORY_OFFERS_SUCCESS',
    SET_PROMO_HISTORY_OFFERS_FAILURE: 'SET_PROMO_HISTORY_OFFERS_FAILURE',

    SET_PROMO_CODE_SUCCESS: 'SET_PROMO_CODE_SUCCESS',
    SET_PROMO_CODE_FAILURE: 'SET_PROMO_CODE_FAILURE',
}